/**
 * Progressive reveal for zg-* sections: elements marked [data-zg-reveal] that start below the fold
 * fade and rise into place once when they scroll into view. Content is visible without JS, with
 * prefers-reduced-motion, and in the theme editor; the hidden state is only ever set from here.
 */
const SELECTOR = '[data-zg-reveal]:not([data-zg-reveal="pending"]):not([data-zg-reveal="shown"])';

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

/** @type {IntersectionObserver | null} */
let observer = null;

function getObserver() {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.setAttribute('data-zg-reveal', 'shown');
          observer?.unobserve(entry.target);
        }
      },
      { threshold: 0.12 }
    );
  }
  return observer;
}

/** @param {ParentNode} root */
function arm(root) {
  if (reducedMotion.matches || window.Shopify?.designMode) return;

  for (const element of root.querySelectorAll(SELECTOR)) {
    if (element.getBoundingClientRect().top < window.innerHeight - 40) {
      element.setAttribute('data-zg-reveal', 'shown');
      continue;
    }
    element.setAttribute('data-zg-reveal', 'pending');
    getObserver().observe(element);
  }
}

arm(document);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) arm(event.target);
});
